import Vue from 'vue'
import Movie from '@/models/Movie'
import Person from '@/models/Person'
import Review from '@/models/Review'
import Api from '@/api/Api'

# This vuex module groups all the actual data about movies

state = 
    movies: new Map() # Movie id -> Movie object
    movies_changes: 0 # count movies changed to enable reactivity on movies Map (Maps are not reactive)
    movies_year_loaded: new Map() # year -> lowest vote count loaded
    movie_fields: []
    movie_types: []
    movies_loading: new Map() # year -> currently loading true of false

    persons: new Map() # Person id -> Person object (sorted by cumulative vote count)
    persons_changes: 0 # count persons changed to enable reactivity on persons Map (Maps are not reactive)
    persons_filter: [] # we should only show movies that have person ids in this list

    reviews: {} # map of movie_id to review
    graphs: {} # map of movie_id to graph

    search_actor: 'hello'

getters =
    details: (state) ->
        return state.movies.get(state.details_id)

    year_count: (state, getters, rootState) ->
        a = state.movies_changes
        year_min = rootState.filter.range.year.lower_bound
        year_max = rootState.filter.range.year.upper_bound
        counter = {}
        counter[year] = 0 for year in [year_min..year_max]
        state.movies.forEach (movie, id) ->
            counter[movie.year] += 1
        return counter

mutations =
    addMovies: (state, movies) ->
        # movies is a dict of movie_id to a list of values
        for key, item of movies
            tmp = {}
            for i in [0..state.movie_fields.length]
                tmp[state.movie_fields[i]] = item[i]
            tmp['id'] = parseInt(key)
            tmp['type'] = state.movie_types[tmp['type_id']]
            m = new Movie(tmp)
            state.movies.set(m.id, m)
    setMovieFields: (state, fields) ->
        state.movie_fields = fields
    setMovieTypes: (state, types) ->
        state.movie_types = types
    refreshMovies: (state) ->
        state.movies_changes += 1
    loadedMoviesRange: (state, range) ->
        for year in [range['year_to']..range['year_from']]
            state.movies_year_loaded.set(year, range['votes_to'])
        console.log state.movies_year_loaded

    addPerson: (state, person) ->
        state.persons.set(person.id, person)
    refreshPersons: (state) ->
        state.persons_changes += 1



    patchMovie: (state, data) ->
        state.movies.get(data.id)[data.field] = data.value
    addReview: (state, review) ->
        id = review.movie_id
        state.movies.get(id)["review_id"] = review.id
        state.movies.get(id)["own_score"] = review.score
        state.movies.get(id).determineClass()
        state.movies.get(id).determineColors()
        Vue.set(state.reviews, review.movie_id, review)
    addGraph: (state, data) ->
        Vue.set(state.graphs, data.movie_id, data.graph)

    addSummary: (state, data) ->
        state.movies.get(data.movie_id)["summary"] = data.summary
        state.movies_changes += 1
        
    addPersons: (state, data) ->
        for key, item of data
            tmp = {}
            tmp['id'] = key
            tmp['type'] = item[0]
            tmp['name'] = item[1]
            tmp['imdb_url'] = item[2]
            tmp['imdb_votes_sum'] = item[3]
            tmp['imdb_movies_num'] = item[4]
            tmp['imdb_score_weighted'] = item[5]
            tmp['rank_by_type'] = item[6]
            p = new Person(tmp)
            state.persons.set(p.id, p)

    setScoreRangeImdb: (state, range) ->
        state.score_range_imdb = range
    setScoreRangeMetacritic: (state, range) ->
        state.score_range_metacritic = range
    setYearRange: (state, range) ->
        state.year_range = range
    setRuntimeRange: (state, range) ->
        state.runtime_range = range

    togglePersonFilter: (state, person_id) ->
        index = state.persons_filter.indexOf(person_id)
        if index >= 0
            state.persons_filter.splice(index, 1)
        else
            state.persons_filter.push(person_id)

actions =
    loadMovies: ({commit, dispatch}, range) ->
        console.log "fetching movies in range", range
        {year_from, year_to, votes_from, votes_to, meta_info} = range

        # Mark the years as loading in progress
        for year in [year_from..year_to]
            state.movies_loading.set(year, true)

        Api.movie.get(year_from, year_to, votes_from, votes_to, meta_info)
        .then (data) =>
            console.log data
            if meta_info
                # values that are only set on first load
                commit('filter/SET_COUNTRIES', data['countries'], { root: true })
                commit('filter/SET_GENRES', data['genres'], { root: true })
                commit('filter/SET_LANGUAGES', data['languages'], { root: true })
                commit('setMovieFields', data['movie_fields'])
                commit('setMovieTypes', data['movie_types'])

            # add movies
            commit('addMovies', data['movies'])
            commit('loadedMoviesRange', range)
            commit('refreshMovies')
            dispatch('sort/preSortAll', null, { root: true })

            # for key, item of data['persons']
            #     tmp = {}
            #     person_fields = ['name', 'imdb_url', 'type_id']
            #     for i in [0..person_fields.length]
            #         tmp[person_fields[i]] = item[i]
            #     tmp['id'] = parseInt(key)
            #     tmp['type'] = data['person_types'][tmp['type_id']]
            #     p = new Person(tmp)
            #     commit('addPerson', p)
            # commit('refreshPersons')

            # Mark the years as no longer loading
            for year in [year_from..year_to]
                state.movies_loading.set(year, false)

    loadMoreMovies: ({commit, dispatch, state, rootState}, year) ->
        if state.movies_loading.get(year) # do not load if it's already loading
            return
        if year == 'All'
            year_from = rootState.filter.year.upper_bound
            year_to = rootState.filter.year.lower_bound
            votes_from = 9999999
            votes_to = 5000
        else
            year_from = year
            year_to = year
            votes_from = if state.movies_year_loaded.has(year) then state.movies_year_loaded.get(year) else 9999999
            if votes_from == 100 # do not load further than 100
                return
            votes_to = 5000
            votes_to = 1000 if votes_from == 5000
            votes_to = 100 if votes_from == 1000
        dispatch 'loadMovies',
            'year_from': year_from
            'year_to': year_to
            'votes_from': votes_from
            'votes_to': votes_to
            'meta_info': false
    setMovieHiddenState: ({commit}, obj) ->
        {id, hidden} = obj
        Api.movie.changeHidden id, hidden
        .then (data) =>
            console.log data
            commit 'patchMovie',
                'id': data.id
                'field': 'hidden'
                'value': data.hidden
            commit('refreshMovies')
    addToCollection: ({commit}, id) ->
        Api.collection.add id
        .then (data) =>
            commit 'patchMovie',
                'id': id
                'field': 'collection_time'
                'value': data.time
            commit('refreshMovies')
    loadReview: ({commit}, movie_id) ->
        Api.review.get movie_id
        .then (data) =>
            console.log "REVIEW DATA"
            console.log data
            if data['review']
                commit 'addReview', new Review(data['review'])
            commit 'addGraph',
                'movie_id': movie_id
                'graph': data['graph']
            commit 'addSummary',
                'movie_id': movie_id
                'summary': data['summary']
            commit 'addPersons', data['persons']
            commit 'patchMovie',
                'id': movie_id
                'field': 'person_ids'
                'value': Object.keys(data['persons'])

    saveReview: ({commit}, review) ->
        console.log "Saving review"
        console.log review
        if review.id # update to existing review
            Api.review.patch review.id, review
            .then (data) ->
                console.log "PATCHED REVIEW"
                console.log data
                commit 'addReview', new Review(data)
                commit 'refreshMovies'
        else # new review
            console.log "Pushing review"
            Api.review.post review.movie_id, review
            .then (data) ->
                console.log "ADDED REVIEW"
                console.log data
                commit 'addReview', new Review(data)
                commit 'refreshMovies'


    toggleReviewEpisode: ({commit, state}, {movie_id, index}) ->
        console.log "Toggling ", movie_id, index
        movie = state.movies.get(movie_id)
        episode_id = movie.episode_ids[index]
        if movie.episode_reviews[index]
            Api.review_episode.unset(episode_id)
            .then (data) ->
                movie.episode_reviews[index] = 0
                movie.episode_num_reviewed -= 1
                movie.determineBackgroundStyle()
                commit('refreshMovies')
        else
            Api.review_episode.set(episode_id)
            .then (data) ->
                movie.episode_reviews[index] = 1
                movie.episode_num_reviewed += 1
                movie.determineBackgroundStyle()
                commit('refreshMovies')

    toggleReviewSeason: ({commit, state}, {movie_id, indices}) ->
        console.log "Toggling ", movie_id, indices
        movie = state.movies.get(movie_id)

        # get all the episodes that are not reviewed
        episode_ids = (movie.episode_ids[index] for index in indices when not movie.episode_reviews[index])

        # if we found any, then set them all
        if episode_ids.length
            Api.review_episode.set_bulk(episode_ids)
            .then (data) ->
                for index in indices
                    movie.episode_reviews[index] = 1
                movie.episode_num_reviewed += episode_ids.length
                movie.determineBackgroundStyle()
                commit('refreshMovies')
        # no unreviewed episodes means we should unset them all
        else
            episode_ids = (movie.episode_ids[index] for index in indices)
            Api.review_episode.unset_bulk(episode_ids)
            .then (data) ->
                for index in indices
                    movie.episode_reviews[index] = 0
                movie.episode_num_reviewed -= episode_ids.length
                movie.determineBackgroundStyle()
                commit('refreshMovies')

    togglePersonFilter: ({commit}, id) ->
        commit 'togglePersonFilter', id

export default {
    namespaced: true
    state
    getters
    mutations
    actions
}
